// Wordpress URL
export const URL = pressword_ajax.ajax_url;

// APIs
export const GET_APIS = 'GET_APIS'
export const POST_API = 'POST_API'
export const DELETE_API = 'DELETE_API'
export const BULK_API = 'BULK_API'
export const POST_API_SUCCESS = 'POST_API_SUCCESS'
export const POST_API_ERROR = 'POST_API_ERROR'
export const GET_APIS_SUCCESS = 'GET_APIS_SUCCESS'
export const GET_APIS_ERROR = 'GET_APIS_ERROR'
export const DELETE_API_SUCCESS = 'DELETE_API_SUCCESS'
export const DELETE_API_ERROR = 'DELETE_API_ERROR'
export const BULK_API_SUCCESS = 'DELETE_API_SUCCESS'
export const BULK_API_ERROR = 'DELETE_API_ERROR'

// visibility
export const ROUTE_VISIBILITY = 'ROUTE_VISIBILITY'
